
import { useQuery } from '@tanstack/react-query';
import { fetchLegalSettings } from '@/services/appSettingsService';

export const useLegalSettings = () => {
  return useQuery({
    queryKey: ['legalSettings'],
    queryFn: fetchLegalSettings,
    staleTime: 1000 * 60 * 60, // Cache for 1 hour
  });
};
